"use strict";

(function ($) {

	/**
  * Breadcrumb
  *
  * @author Matthias Giger <matthias.giger@namics.com>
  */
	T.Module.Breadcrumb = T.createModule({
		start: function start(resolve) {
			this.$ctx = $(this._ctx);
			resolve();
		}
	});
})(jQuery);